import { BookingFilterConfig, FilterNameEnum, FilterTypeEnum } from '@shared/booking-feature';

export const bookingFiltersConfig: BookingFilterConfig = {
    fields: [
        {
            field: FilterNameEnum.SERVICE,
            required: false,
            disabled: true,
            isActive: true,
            order: 1,
            type: FilterTypeEnum.TEXT,
            placeholder: '',
            icon: 'la-stethoscope',
            undefinedText: '',
        },
        {
            field: FilterNameEnum.LOCATION,
            required: false,
            disabled: false,
            isActive: true,
            order: 2,
            type: FilterTypeEnum.SELECT,
            placeholder: $localize`Filter region`,
            icon: 'la-map-marker',
            undefinedText: $localize`Anywhere`,
        },
        {
            field: FilterNameEnum.DATE,
            required: false,
            disabled: false,
            isActive: true,
            order: 3,
            type: FilterTypeEnum.DATE,
            placeholder: $localize`Filter preferred date`,
            icon: 'la-calendar',
            undefinedText: $localize`Anytime`,
        },
        {
            field: FilterNameEnum.CONTRACTOR,
            required: false,
            disabled: false,
            isActive: true,
            order: 4,
            type: FilterTypeEnum.SELECT,
            placeholder: $localize`Filter preferred center`,
            icon: 'la-hospital',
            undefinedText: $localize`All`,
        },
        {
            field: FilterNameEnum.SUBCONTRACTOR,
            required: false,
            disabled: false,
            isActive: true,
            order: 5,
            type: FilterTypeEnum.SELECT,
            placeholder: $localize`Filter subcontractor`,
            icon: 'la-user-nurse',
            undefinedText: $localize`Anyone`,
        },
    ],
};
